import React from 'react'
import { Collapse } from 'antd'

import { ResumeAirRequestQuoteAirs } from 'src/types'

import { WrapCollapsePanel, WrapRow } from './styles'
import HeaderItem from './header-item'
import InfoItem from './info-item'

import { PickFareProps } from '../SearchResultCard'

type Props = PickFareProps & {
  searchKey: string
  list: ResumeAirRequestQuoteAirs[]
}

function SearchResultItem({
  selectedFares,
  onPickFare,
  searchKey,
  list
}: Props) {
  return (
    <Collapse bordered={false} destroyInactivePanel>
      {list.map((airItem, index: number) => (
        <WrapCollapsePanel
          header={
            <HeaderItem
              item={airItem}
              selectedFares={selectedFares}
              onPickFare={onPickFare}
              searchKey={searchKey}
            />
          }
          key={index}
        >
          <WrapRow>
            {airItem.request_quote_air_flights.map(flightItem => (
              <InfoItem key={flightItem.flight_code} item={flightItem} />
            ))}
          </WrapRow>
        </WrapCollapsePanel>
      ))}
    </Collapse>
  )
}

export default SearchResultItem
